export const COLORS = {
    black: {
        lightest: '#d8d8d8',
        inactive: '#a8a8a8',
        lighter: '#545454',
        DEFAULT: '#1f1f1f',
        pure: '#000000',
    },
    white: {
        dark: '#ebecf1',
        background: '#f6f7f9',
        DEFAULT: '#ffffff',
    },
    blue: {
        lightest: '#96e6f0',
        light: '#39b8d5',
        DEFAULT: '#006982',
        dark: '#00566b',
    },
    red: {
        light: '#f49471',
        DEFAULT: '#eb5f2d',
        dark: '#97310c',
    },
    purple: {
        light: '#c8b9ff',
        DEFAULT: '#5a46d7',
        dark: '#3d29bc',
    },
    pink: {
        light: '#fac8d2',
        DEFAULT: '#f12989',
        dark: '#a30a54',
    },
    yellow: {
        DEFAULT: '#ffdc8c',
        dark: '#c1801f',
    },
    green: {
        light: '#96fab5',
        DEFAULT: '#50eb82',
        dark: '#0e5d27',
    },
};
